<template lang='pug'>
v-jumbotron
  v-container(fill-height)
    v-layout(align-center)
      v-flex
        h3(class="display-3") Сброс пароля прошел успешно!
        span(class="subheading") Мы обязательно вернемся к тебе с обратной связью.
        v-divider(class='my-3')
        div(class='title mb-3')
          | Жди письмо на почту &nbsp;
          u {{ $route.query.mail }}
</template>

<script>
export default {}
</script>
